import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";
import Store from "..";

const initialState = {
  surveysHistoryList: [],
  search: "",
  pageIndex: 1,
  pageTotal: 0,
  itemsPerPage: Number(process.env.REACT_APP_PAGE_LIST) || 5,
  order: "name",
  orderAs: "asc",
};

/**
 * Get survey completed survey list
 */
export const getSurveyHistory = (citizenId: any) => async (dispatch: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const search = Store.getState().surveysHistory.search;
    const orderAs = Store.getState().surveysHistory.orderAs;
    const order = Store.getState().surveysHistory.order;
    const itemsPerPage = Store.getState().surveysHistory.itemsPerPage;
    const pageIndex = Store.getState().surveysHistory.pageIndex;

    const list = await HttpService.get(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guest/${citizenId}/survey-answers?itemsPerPage=${itemsPerPage}&page=${pageIndex}&orderBy=${order}&orderAs=${orderAs}&search=${search}`
    );

    if (list.data) {
      dispatch(updateSurveyHistory(list.data.result));
      dispatch(
        updatePageTotal(Math.ceil(Number(list.data.totalItems) / itemsPerPage))
      );
    }
  } catch (e) {
    console.log("fetch Surveys history:", e);
  }
};

/**
 * update pagination number
 */
export const updatePageIndex = (pageIndex: Number) => async (dispatch: any) => {
  try {
    dispatch(updatePage(pageIndex));
  } catch (e) {
    console.log("update search value:", e);
  }
};

export const searchLoadSurvey =
  (search: string, id: any) => async (dispatch: any) => {
    try {
      await dispatch(updateSearchSurveyHistory(search));
      await dispatch(getSurveyHistory(id));
    } catch (e) {
      console.log("Search surveys", e);
    }
  };

/**
 * update survey history table pagination  number
 */
export const updateSurveyHistoryPageIndex =
  (pageIndex: Number) => async (dispatch: any) => {
    try {
      dispatch(updatePage(pageIndex));
    } catch (e) {
      console.log("update search value:", e);
    }
  };

/**
 * Get survey by Id
 */
export const getSurveyAnswers =
  (surveyId: any, citizenId: any) => async (dispatch: any) => {
    try {
      const eventId = Store.getState().login.eventId;
      const list = await HttpService.get(
        `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guest/${citizenId}/survey-answers/${surveyId}`
      );
      if (list.data) {
        return list.data;
      }
    } catch (e) {
      console.log("fetch survey detail:", e);
    }
  };

const surveyHistoryReducer = createSlice({
  name: "surveysHistory",
  initialState,
  reducers: {
    updateSurveyHistory(state, action: PayloadAction<any>) {
      state.surveysHistoryList = action.payload;
    },
    updatePageTotal(state, action: PayloadAction<any>) {
      state.pageTotal = action.payload;
    },
    updatePage(state, action: PayloadAction<any>) {
      state.pageIndex = action.payload;
    },
    updateOrder(state, action: PayloadAction<any>) {
      state.order = action.payload;
    },
    updateOrderAs(state, action: PayloadAction<any>) {
      state.orderAs = action.payload;
    },
    updateSearchSurveyHistory(state, action: PayloadAction<any>) {
      state.search = action.payload;
    },
  },
});

export const {
  updateSurveyHistory,
  updatePageTotal,
  updateOrder,
  updateOrderAs,
  updatePage,
  updateSearchSurveyHistory,
} = surveyHistoryReducer.actions;

export default surveyHistoryReducer.reducer;
